import { render, staticRenderFns } from "./WalletItem.vue?vue&type=template&id=5ffce28e&scoped=true&"
import script from "./WalletItem.vue?vue&type=script&lang=ts&"
export * from "./WalletItem.vue?vue&type=script&lang=ts&"
import style0 from "./WalletItem.vue?vue&type=style&index=0&id=5ffce28e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffce28e",
  null
  
)

export default component.exports